import React, { useState, useEffect } from 'react';
import DataTable from '../Common/DataTable';
import { api } from '../../services/api';

export default function WorkReports({ user, selectedContractId, search, tableActionsRef }) {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!selectedContractId || !user) return;

    setColumns([]);
    setData([]);

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await api.getReport(
          user.userCode,
          user.type,
          selectedContractId
        );
        
        if (response.columns && response.data) {
          setColumns(response.columns);
          setData(response.data);
        } else if (Array.isArray(response)) {
          setData(response);
          setColumns([]);
        } else if (response.data) {
          setColumns(response.columns || []);
          setData(response.data);
        } else {
          setData([]);
          setColumns([]);
        }
      } catch (err) {
        console.error('Error fetching work reports:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedContractId, user]);

  if (loading && columns.length === 0) {
    return (
      <div className="report-panel report-panel--state">
        <div className="report-state-message">טוען...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="report-panel report-panel--state">
        <div className="report-state-message report-state-message--error">
          שגיאה בטעינת הדוח: {error}
        </div>
      </div>
    );
  }

  if (!columns || columns.length === 0) {
    return (
      <div className="report-panel report-panel--state">
        <div className="report-state-message">אין עמודות להצגה</div>
      </div>
    );
  }

  return (
    <div className="report-panel">
      <DataTable ref={tableActionsRef} columns={columns} data={data} search={search} />
    </div>
  );
}
